import { Box } from 'pixelize-design-library';
import { useEffect, useState } from 'react';

import { LoadingFallback } from './LoadingFallback';

// Below this a route chunk needs no loader; one that appears and vanishes reads as a glitch.
const DELAY_MS = 250;

interface DeferredFallbackProps {
  text?: string;
  minH?: string;
}

export function DeferredFallback({ text, minH = '60vh' }: DeferredFallbackProps) {
  const [waited, setWaited] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setWaited(true), DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  if (!waited) return <Box minH={minH} w='100%' data-testid='deferred-fallback' />;

  return <LoadingFallback text={text} minH={minH} />;
}
